"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => ({
    root: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: props => props.maxWidth
    }
});
//# sourceMappingURL=textEllipsis.style.js.map